<div class="header">
    <a href="/">
        <img class="logo" src='/assets/trends/allerganlogo1.png'/>
        <img class="logo-sm" src='/assets/trends/allerganlogo2.png'/>
    </a>
</div>
